import type { MatasPlusChangeSubscriptionTypeModal } from 'autogen/swagger/all';
import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';

export const ChangeSubscriptionTypeAtom = mediatorAtom<{
    isOpen: boolean;
    model?: MatasPlusChangeSubscriptionTypeModal;
}>({
    isOpen: false
});

export default function useChangeSubscriptionType() {
    return useMediatorState(ChangeSubscriptionTypeAtom);
}
